export const generalSettingModel = {
  default_weight_unit: "",
  default_fuel_unit: "",
  crew_age_validation: 0,
  default_quantity_unit_for_fuel_prices: 0,
  flight_max_delay: "00:00",
};
